export default __webpack_public_path__ + "static/media/contact-img.8d12bbf1.svg";